export function TvIcon({ size = 80 }: { size?: number }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 20"
      width={size}
      height={size * (20 / 24)}
      shapeRendering="crispEdges"
      aria-hidden="true"
      role="presentation"
      style={{ color: "var(--color-yellow-bright)" }}
    >
      {/* Antennas */}
      <rect x="5" y="0" width="1" height="4" fill="currentColor" />
      <rect x="6" y="1" width="1" height="3" fill="currentColor" />
      <rect x="17" y="0" width="1" height="4" fill="currentColor" />
      <rect x="16" y="1" width="1" height="3" fill="currentColor" />
      {/* Casing */}
      <rect x="1" y="4" width="22" height="14" fill="currentColor" />
      {/* Screen */}
      <rect x="3" y="6" width="14" height="10" fill="#000" />
      {/* Screen content — color bars */}
      <rect x="4" y="7" width="3" height="3" fill="#FFF000" />
      <rect x="7" y="7" width="3" height="3" fill="#33E2F2" />
      <rect x="10" y="7" width="3" height="3" fill="#B81BC8" />
      <rect x="13" y="7" width="3" height="3" fill="#30EB27" />
      <rect x="4" y="11" width="12" height="1" fill="#0034FF" />
      <rect x="4" y="13" width="12" height="2" fill="#050505" />
      {/* Speaker grill */}
      <rect x="18" y="7" width="4" height="1" fill="#000" />
      <rect x="18" y="9" width="4" height="1" fill="#000" />
      <rect x="18" y="11" width="4" height="1" fill="#000" />
      <rect x="18" y="13" width="4" height="1" fill="#000" />
      {/* Feet */}
      <rect x="3" y="18" width="3" height="2" fill="currentColor" />
      <rect x="18" y="18" width="3" height="2" fill="currentColor" />
    </svg>
  );
}
